import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-create-permission-dialog',
  templateUrl: './confirm-create-permission-dialog.component.html',
  styleUrls: ['./confirm-create-permission-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmCreatePermissionDialogComponent {
  srcImg = 'assets/images/check-card.png';

  constructor(
    public _dialogRef: MatDialogRef<ConfirmCreatePermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { action: string }
  ) {}

  close() {
    this._dialogRef.close();
  }
}
